
import LocalStats from '@/types/LocalStats'
import { defineComponent, PropType } from 'vue'

const graphHeight = 200;
const minBarHeight = 28;

const __default__ = defineComponent({
    props: {
        localStats: {
            required: true,
            type: Object as PropType<LocalStats>,
        }
    },
    data() {
        return {
            enabledColor: '#007AA5',
            disabledColor: '#898E8C',
            lostColor: '#D12D33',
            graphHeight: `${graphHeight}px`,
        }
    },
    methods: {
        getBarStyle(count: number, lost = false) {
            const games = this.localStats.amountOfGames;
            const heightPercentage = games == 0 ? 0 : count/games;
            return {
                backgroundColor: count == 0 ?  this.disabledColor
                    : lost ? this.lostColor : this.enabledColor,
                height: `${heightPercentage*(graphHeight-minBarHeight) + minBarHeight}px`,
            };
        },
    }
})

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "cbe82a58": (_ctx.graphHeight)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__